import React from 'react'
import { Body3 } from '@flatsy/core/MaterialUi/Typo'
import { Button, Grid, Collapse } from '@material-ui/core'

import CheckIcon from '@flatsy/core/Icon/Check'
import { ComponentProps } from './Type'
import useStyles from './Style'

const ReasonItem: React.FC<ComponentProps> = ({
  label,
  color,
  isSelected = false,
  expandable = false,
  handleSelect,
  children,
}) => {
  const classes = useStyles({ isSelected })

  return (
    <Grid container direction="column" className={classes.root}>
      <Button className={classes.button} onClick={handleSelect} disableRipple disableFocusRipple>
        <Grid container className={classes.title}>
          {isSelected && <CheckIcon />}
          <Body3 className={classes.item} fontColor={color}>
            {label}
          </Body3>
        </Grid>
      </Button>
      <Collapse in={expandable && isSelected}>
        <Grid container direction="column" className={classes.content}>
          {children}
        </Grid>
      </Collapse>
    </Grid>
  )
}

export default ReasonItem
